import React, { useEffect, useState } from 'react';
import { Link, Text, withSitecoreContext} from "@sitecore-jss/sitecore-jss-react";
import { RoutableLink } from '../../react/RoutableLink';
import { Sizes, Colors } from '../../ts/enums';
import { Button } from '../../react/Button';
import css from './index.module.scss';

const isDesktop = () => (typeof window !== 'undefined' && window.innerWidth > 900);
let delayTimer;
let navigationContentItem;

const DelayHover = (e) => {
    if (isDesktop()) {
        // Get target - if hasDropdown, good, else find parent li
        let target = e.target.classList.contains(css.hasDropdown) ? e.target : e.target.closest('li');
        navigationContentItem =  document.querySelector(`*[data-navcontainer=true]`);
        
        let linkTarget = target.querySelector('a:first-child');

        delayTimer = setTimeout(() => {
            target.setAttribute('data-showdropdown', 'true');
            if(linkTarget.hasAttribute('aria-expanded')) {
                linkTarget.setAttribute('aria-expanded', 'true');
            }
            navigationContentItem.setAttribute('data-showdropdown', 'true');
        }, 550);
    }
}

const RemoveHover = () => {
    if (isDesktop()) {
        clearTimeout(delayTimer);
        let openDropdowns = document.querySelectorAll(`*[data-showdropdown=true]`);
        openDropdowns.forEach((dropdown) => {
            let linkTarget = dropdown.querySelector('a:first-child');
            dropdown.removeAttribute('data-showdropdown');
            if(linkTarget.hasAttribute('aria-expanded')) {
                linkTarget.setAttribute('aria-expanded', 'false');
            }
        });
    }
}

const handleKeyDown = (e) => {
    if (e.key === ' ' || e.key === 'Enter') {
        let currentState = e.target.closest('li').getAttribute('data-mobilenavdropdownisopen') === 'true';
        e.target.closest('li').setAttribute('data-mobilenavdropdownisopen', !currentState);
    }
  };

const ShowMobileDropdown = (e) => {
    if (typeof window !== 'undefined' && window.innerWidth <= 900) {
        let currentState = e.target.getAttribute('data-mobilenavdropdownisopen') === 'true';
        e.target.setAttribute('data-mobilenavdropdownisopen', !currentState);
    }
}

const HideMobileDropdown = () => {
    let navListItem = document.querySelector('li[data-mobilenavdropdownisopen=true');
    navListItem.setAttribute('data-mobilenavdropdownisopen', 'false');
}

const GeneralNavigation = ({ fields, ResetNavHandler }) => {
    const children = fields?.children ? fields?.children : [null, null];
    const [leftLinks, rightLinks] = children;
    const leftLinksFields = leftLinks?.fields?.children;

    const [currentPagePath, setPagePath] = useState('');

    useEffect(() => {
        setPagePath(decodeURI(window?.location?.pathname)?.toLowerCase());
        // navigationContentItem =  document.querySelectorAll(`*[data-navcontainer=true]`);
    });

    const isCurrentPage = (link) => {
        return link?.value?.href ? link.value.href.toLowerCase() === currentPagePath : false;
    };

    return (
        <nav id="main-navbar" className={css.container} aria-label='Main'>
            <div className='single-col-inner'>
                <div className={css.navContainer}>
                    <ul className={`${css.navList} ${css.leftNav}`}>
                        {
                            leftLinksFields?.length > 0 &&
                            <NavList sectionLinks={leftLinksFields}
                                isCurrentPageHandler={isCurrentPage}
                                ResetNavHandler={ResetNavHandler} />
                        }
                    </ul>
                    
                </div>
            </div>
        </nav>
    );
}

// Takes a navlist section, left or right, and generates the necessary markup
const NavList = ({ sectionLinks, isCurrentPageHandler, ResetNavHandler }) => {
    const closeSearchFlyout = () =>{
        let currentState = document.body.getAttribute('data-searchopen')
        
           if(currentState === 'true'){
            document.body.setAttribute('data-searchopen', 'false');
           }
        

         // Update tabindexes for keyboard tabbing, -1 is 'not tabbable' when search form is closed, 0 is 'tabbable' when open
        let allSearchActions = document.body.querySelectorAll(`div[class*='GeneralHeader_searchFlyout'] *[tabindex]`);
        allSearchActions.forEach(function (action) {
            action.setAttribute('tabIndex', currentState ? '-1' : '0');
        });
        ResetNavHandler();
    }
    return (
        sectionLinks?.map((sectionLink, index) => {
            const sectionLinkFields = sectionLink?.fields;
            const linkText = sectionLinkFields?.linkText || sectionLinkFields?.title;
            const linkIsHighlight = sectionLinkFields?.highlight?.value;
            const hasDropdown = sectionLinkFields?.children?.length > 0;


            return (
                (sectionLinkFields?.link?.value?.href && linkText?.value) ?
                    <li className={`${css.navListItem}${hasDropdown ? ` ${css.hasDropdown}` : ''}`}
                        data-mobilenavdropdownisopen={false}
                        key={`nav-link-${index}`}
                        onMouseEnter={!linkIsHighlight ? DelayHover : null}
                        onMouseLeave={!linkIsHighlight ? RemoveHover : null}
                        onFocus={!linkIsHighlight ? DelayHover : null}
                        onBlur={!linkIsHighlight ? RemoveHover : null}
                        onClick={hasDropdown ? ShowMobileDropdown : null}
                        onKeyDown={hasDropdown ? handleKeyDown : null}
                        aria-label={(typeof window !== 'undefined' && window.innerWidth <= 900) ? `Show nav dropdown for ${linkText?.value}` : ''}>
                        <RoutableLink
                            onClick={()=>closeSearchFlyout()}
                            field={sectionLinkFields.link}
                            data-iscurrentpage={isCurrentPageHandler(sectionLinkFields.link)}
                            aria-expanded={hasDropdown ? 'false' : undefined}
                            aria-contols={hasDropdown ? linkText.value : undefined}
                            className={`${css.l1Link}${linkIsHighlight ? ` ${css.linkHighlight}` : ''}`}>
                                {
                                    hasDropdown  &&
                                    <Text field={linkText} />
                                }
                            
                                {
                                    linkIsHighlight  &&
                                    <Text field={linkText} />
                                }
                                {
                                !linkIsHighlight && !hasDropdown &&
                                   <Text field={linkText} />
                                } 

                        </RoutableLink>

                        {
                            hasDropdown &&
                            <div className={css.linkDropdown} role="menu" id={linkText.value}>
                                <div className={css.linksubDropdown}>
                                    <button aria-label='Back' onClick={HideMobileDropdown} className={css.backButton}>Back</button>

                                    {/* Mobile L1: */}
                                    <RoutableLink
                                        // onClick={ResetNavHandler}
                                        onClick={()=>closeSearchFlyout()}
                                        field={sectionLinkFields.link}
                                        data-iscurrentpage={isCurrentPageHandler(sectionLinkFields.link)}
                                        aria-expanded={hasDropdown ? 'false' : undefined}
                                        aria-contols={hasDropdown ? linkText.value : undefined}
                                        className={css.l1LinkDropdown} >
                                        <Text field={linkText} />
                                    </RoutableLink>

                                    <ColumnLinks columns={sectionLinkFields.children} 
                                        ResetNavHandler={ResetNavHandler} closeSearchFlyout={closeSearchFlyout}/>
                                </div>
                            </div>
                        }
                        <div className={css.navListOverlay} onMouseOver={RemoveHover} />
                    </li>
                    :
                    null
            )
        })
    )
}

// Takes columns and spits out formatted links
const ColumnLinks = ({ columns, ResetNavHandler, closeSearchFlyout }) => (
    columns?.map((column, columnIndex) => {
        const columnLinks = column?.fields?.children;

        return (
            columnLinks?.length > 0 ?
                <ul key={`colgroup-${columnIndex}`} className={css.linkDropdownColumn}>
                    {
                        // For each link in column group
                        columnLinks.map((columnLink, linkIndex) =>
                            (columnLink?.fields?.link?.value?.href && columnLink.fields?.linkText?.value) &&
                            <li key={`colgroup-${columnIndex}-link-${linkIndex}`} className={css.dropdownSubLinks}>
                                <RoutableLink field={columnLink.fields.link}
                                    className={css.linkDropdownLink}
                                    data-chevron={true}
                                    data-size={Sizes.SMALL}
                                    // onClick={ResetNavHandler}
                                    onClick={()=>closeSearchFlyout()}
                                    >
                                    <Text field={columnLink.fields.linkText} />
                                </RoutableLink>
                            </li>
                        )
                    }
                </ul>
                :
                null
        )
    })
)

export default GeneralNavigation;